import { SeasonalAction, SeasonalState } from "../../Types";

export const seasonalReducer = (state: SeasonalState, action: SeasonalAction): SeasonalState => {
    switch (action.type) {
        case 'SET_PERIOD':
            return {
                ...state,
                selectedPeriod: action.payload,
                selectedFromDate: !action.payload.includes('Custom Date') ? null : state.selectedFromDate,
                selectedToDate: !action.payload.includes('Custom Date') ? null : state.selectedToDate
            };
        
        case 'TOGGLE_PERIOD':
            if (action.payload === 'Custom Date') {
                return {
                    ...state,
                    selectedPeriod: state.selectedPeriod?.includes('Custom Date') 
                        ? []
                        : ['Custom Date'],
                    selectedFromDate: state.selectedPeriod?.includes('Custom Date') ? null : state.selectedFromDate,
                    selectedToDate: state.selectedPeriod?.includes('Custom Date') ? null : state.selectedToDate
                };
            } else {
                const currentSelection = state.selectedPeriod || [];
                const newSelection = currentSelection.includes(action.payload)
                    ? currentSelection.filter(p => p !== action.payload)
                    : [...currentSelection.filter(p => p !== 'Custom Date'), action.payload];
                
                return {
                    ...state,
                    selectedPeriod: newSelection.length === 0 ? undefined : newSelection
                };
            }
            
        case 'TOGGLE_DROPDOWN':
            return { ...state, isOpen: !state.isOpen };
            
        case 'CLOSE_DROPDOWN':
            return { ...state, isOpen: false };
            
        case 'SET_FROM_DATE':
            return { ...state, selectedFromDate: action.payload };
            
        case 'SET_TO_DATE':
            return { ...state, selectedToDate: action.payload };
            
        default:
            return state;
    }
};